import { useEffect, useState } from 'react';

import { setupForDark } from '@theme';
import classNames from 'classnames';

function Chip({
  text,
  type = 'all',
  isSelected = false,
  onClick = () => {}
}: {
  text: string;
  type: 'all' | 'time' | 'task' | 'tag' | 'weather' | 'group';
  isSelected?: boolean;
  onClick?: () => void;
}) {
  const [isSelectedInternal, setIsSelectedInternal] = useState(false);

  useEffect(() => {
    setIsSelectedInternal(isSelected);
  }, [isSelected]);

  let classes = '';
  switch (type) {
    case 'all':
      classes = classNames(
        !isSelectedInternal ? setupForDark('text-tertiary') : setupForDark('text-secondary'),
        !isSelectedInternal ? '' : setupForDark('bg-chip-selected'),
        setupForDark('border-primary')
      );
      break;
    case 'time':
      classes = classNames(
        !isSelectedInternal ? setupForDark('text-variable-red') : setupForDark('text-black'),
        !isSelectedInternal ? '' : setupForDark('bg-variable-red'),
        setupForDark('border-variable-red')
      );
      break;
    case 'task':
      classes = classNames(
        !isSelectedInternal ? setupForDark('text-variable-blue') : setupForDark('text-black'),
        !isSelectedInternal ? '' : setupForDark('bg-variable-blue'),
        setupForDark('border-variable-blue')
      );
      break;
    case 'tag':
      classes = classNames(
        !isSelectedInternal ? setupForDark('text-variable-green') : setupForDark('text-black'),
        !isSelectedInternal ? '' : setupForDark('bg-variable-green'),
        setupForDark('border-variable-green')
      );
      break;
    case 'weather':
      classes = classNames(
        !isSelectedInternal ? setupForDark('text-variable-yellow') : setupForDark('text-black'),
        !isSelectedInternal ? '' : setupForDark('bg-variable-yellow'),
        setupForDark('border-variable-yellow')
      );
      break;
    case 'group':
      classes = classNames(
        !isSelectedInternal ? setupForDark('text-variable-yellow') : setupForDark('text-black'),
        !isSelectedInternal ? '' : setupForDark('bg-variable-yellow'),
        setupForDark('border-variable-yellow')
      );
      break;
  }

  return (
    <div
      className={classNames(
        'flex justify-center items-center gap-none px-md py-xs rounded-xxxl',
        'cursor-pointer',
        'border-[1px]',
        'P3M',
        classes
      )}
      onClick={() => {
        setIsSelectedInternal((prev) => !prev);
        onClick();
      }}
    >
      {text}
    </div>
  );
}

export default Chip;
